import Modal from '../shared/Modal';

const ScoreCalculationModal = ({ 
  isOpen, 
  onClose, 
  puzzleState 
}) => {
  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      title="Score Calculation"
    >
      <div style={{ textAlign: 'left', padding: '0' }}>
        <p><strong>Score Formula:</strong></p>
        <p>(100 - Incorrect Count) × Difficulty Multiplier</p>
        <br />
        <p><strong>Your Score:</strong></p>
        <p>
          (100 - {puzzleState?.incorrect_count || 0}) × {puzzleState?.settings?.multiplier || 1} = <strong>{puzzleState?.score}</strong>
        </p>
        <br />
        <p style={{ fontSize: '0.9em', color: '#666' }}>
          • Incorrect Count: # of incorrect guesses<br />
          • Difficulty Multiplier:<br />
            &nbsp;&nbsp;- Easy: 0.75<br />
            &nbsp;&nbsp;- Normal: 1.0<br />
            &nbsp;&nbsp;- Hard: 1.5<br />
            &nbsp;&nbsp;- Impossible: 2.0
        </p>
      </div>
    </Modal>
  );
};

export default ScoreCalculationModal;